import { AdminLogo } from "@/assets/admin-logo";
import { useQueryClient } from "@tanstack/react-query";
import { Link, useNavigate } from "@tanstack/react-router";
import { toast } from "sonner";
import { useAuthStore } from "@/features/auth/store/useAuthStore";

export default function AdminNavbar() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      queryClient.clear();
      localStorage.removeItem("auth-storage");
      toast.success("Logout successful");
    } catch {
      toast.error("Logout failed");
    } finally {
      useAuthStore.setState({
        user: null,
        token: null,
        refresh_token: null,
        expiresAt: null,
      });
      localStorage.removeItem("auth-storage");
      navigate({ to: "/login" });
    }
  };
  return (
    <div className="border-black-950 flex items-center justify-between border-b-[2px] px-[120px] py-5">
      <div className="flex items-center gap-2">
        <AdminLogo width={43} height={23} />
        <span className="text-lg leading-none font-bold -tracking-wide text-white">
          metawhale <span className="font-light">admin</span>
        </span>
        {/* <p className="pb-1.5 text-[10px] text-gray-500">
            {import.meta.env.VITE_APP_VERSION}
          </p> */}
      </div>
      <div className="flex space-x-7">
        <Link
          to="/admin/dashboard"
          className="cursor-pointer text-sm leading-none font-medium -tracking-wide"
        >
          Dashboard
        </Link>
        <Link
          to="/admin/client"
          className="cursor-pointer text-sm leading-none font-medium -tracking-wide"
        >
          Clients
        </Link>
        <Link
          to="/admin/requests"
          className="cursor-pointer text-sm leading-none font-medium -tracking-wide"
        >
          Requests
        </Link>
        <Link
          to="/admin/system"
          className="cursor-pointer text-sm leading-none font-medium -tracking-wide"
        >
          System
        </Link>

        <h1
          onClick={handleLogout}
          className="cursor-pointer text-sm leading-none font-medium -tracking-wide"
        >
          Logout
        </h1>
        {/* <p className="cursor-pointer text-sm leading-none font-medium -tracking-wide">
          Accounts
        </p> */}
      </div>
    </div>
  );
}
